// import React, { useEffect, useState } from "react";
// import { db } from "../../firebase";
// import { doc, getDoc } from "firebase/firestore";
// import Banner from "./banner";
// import css from "./foreignRights.module.css";
// import forLocationsForei from "../../img/forLocationsForei.png";
// import facceForForeight from "../../img/facceForForeight.png";
// import mailForForeight from "../../img/mailForForeight.png";
// import tgForForeight from "../../img/tgForForeight.png";

// const ForeignRights = () => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const documentId = "uniqueForeignRight";
//   console.log("data.", data);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const docRef = doc(db, "foreignRights", documentId);
//         const docSnap = await getDoc(docRef);

//         if (docSnap.exists()) {
//           setData(docSnap.data());
//         } else {
//           console.error("Document not found");
//         }
//       } catch (error) {
//         console.error("Error fetching foreign rights data:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchData();
//   }, []);

//   if (loading || !data) {
//     return <div>Loading foreign rights...</div>;
//   }

//   return (
//     <div className={css.wrapForeight}>
//       <Banner />

//       {data.bigImage && (
//         <img
//           src={data.bigImage}
//           className={css.bigPhotoForForeight}
//           alt="Big visual"
//         />
//       )}

//       <div className={css.wrpaBlockForTxt}>
//         <div className={css.withButtonm}>
//           <p className={css.bigTetIn}>{data.bigImageTitle}</p>
//         </div>
//         <p className={css.pIndescNotBan}>
//           {data.titleText}
//           <br />
//           <span className={css.spanInNotBanner}>
//             {data.locationBlock}
//             <br />
//             {data.yearBlock}
//             <br />
//             {data.focusBlock}
//           </span>
//         </p>
//       </div>

//       <div className={css.locations}>
//         <img
//           src={forLocationsForei}
//           className={css.forLocationsForei}
//           alt="Location icon"
//         />
//         <div className={css.locationsInformations}>
//           <p className={css.locationsPBig}>
//             Location: Kyiv, UKRAINE
//             <br /> Foreign rights manager: Alina Mekhed,
//             <br />
//             alina.mekhed@masterclassbook.com
//           </p>
//           <div className={css.wrapSocialIconDown}>
//             <a
//               href="https://www.facebook.com/chasmaistriv"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img
//                 src={facceForForeight}
//                 className={css.facceForForeight}
//                 alt="Facebook"
//               />
//             </a>
//             <a href="mailto:alina.mekhed@masterclassbook.com">
//               <img
//                 src={mailForForeight}
//                 className={css.facceForForeight}
//                 alt="Email"
//               />
//             </a>
//             <a
//               href="https://t.me/chas_maistriv"
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img
//                 src={tgForForeight}
//                 className={css.facceForForeight}
//                 alt="Telegram"
//               />
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ForeignRights;

import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import Banner from "./banner";
import css from "./foreignRights.module.css";
import forLocationsForei from "../../img/forLocationsForei.png";
import facceForForeight from "../../img/facceForForeight.png";
import mailForForeight from "../../img/mailForForeight.png";
import tgForForeight from "../../img/tgForForeight.png";

const ForeignRights = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const documentId = "uniqueForeignRight";
  console.log("data.", data);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const docRef = doc(db, "foreignRights", documentId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setData(docSnap.data());
        } else {
          console.error("Document not found");
        }
      } catch (error) {
        console.error("Error fetching foreign rights data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading || !data) {
    return <div>Loading foreign rights...</div>;
  }

  return (
    <div className={css.wrapForeight}>
      <Banner />

      {data.bigImage && (
        <img
          src={data.bigImage}
          className={css.bigPhotoForForeight}
          alt="Big visual"
        />
      )}

      <div className={css.wrpaBlockForTxt}>
        <div className={css.withButtonm}>
          <p className={css.bigTetIn}>{data.bigImageTitle}</p>
        </div>
        <p className={css.pIndescNotBan}>
          {data.titleText}
          <br />
          <span className={css.spanInNotBanner}>
            {data.locationBlock}
            <br />
            {data.yearBlock}
            <br />
            {data.focusBlock}
          </span>
        </p>
      </div>

      <div className={css.locations}>
        <img
          src={forLocationsForei}
          className={css.forLocationsForei}
          alt="Location icon"
        />
        <div className={css.locationsInformations}>
          <p className={css.locationsPBig}>
            Location: Kyiv, UKRAINE
            <br /> Foreign rights manager: Alina Mekhed,
            <br />
            alina.mekhed@masterclassbook.com
          </p>
          <div className={css.wrapSocialIconDown}>
            <a
              href="https://www.facebook.com/chasmaistriv"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={facceForForeight}
                className={css.facceForForeight}
                alt="Facebook"
              />
            </a>
            <a href="mailto:alina.mekhed@masterclassbook.com">
              <img
                src={mailForForeight}
                className={css.facceForForeight}
                alt="Email"
              />
            </a>
            <a
              href="https://t.me/chas_maistriv"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={tgForForeight}
                className={css.facceForForeight}
                alt="Telegram"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForeignRights;
